import { GenericService } from './generic.service';
import { Organisation } from '@/models';

export class CopdAssignableOrganisationService extends GenericService<Organisation> {

  constructor() {
    super('copd/assignable-organisations');
  }
}
